import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { isNil, upperFirst } from 'lodash'
import withRouter from '../../lib/withRouter'
import actions from '../../actions/Users'

export class CarrierUserShow extends Component {
  static propTypes = {
    show: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    attributes: PropTypes.object,
    params: PropTypes.object,
    // eslint-disable-next-line react/no-unused-prop-types
    configuration: PropTypes.object
  }

  componentDidMount() {
    this.props.show(this.id)
  }

  componentWillUnmount() {
    this.props.reset()
  }

  get id() {
    return this.props.params.id
  }

  get carrierBrandRows() {
    const labels = this.props.attributes.carrier_brands.map((u) => u.name)
    const rows = []

    rows.push(
      <tr key="issuers-0">
        <td><strong>Carrier Brands</strong></td>
        <td>{labels[0]}</td>
      </tr>
    )

    return rows.concat(labels.slice(1).map((label, index) => (
      <tr key={`carrier-brand-${index + 1}`}>
        <td />
        <td>{label}</td>
      </tr>
    )))
  }

  render() {
    const { attributes } = this.props

    if (isNil(attributes)) {
      return null
    }

    return (
      <div className="content">
        <h2>User Info</h2>
        <table className="pure-table">
          <tbody>
            <tr>
              <td><strong>Username</strong></td>
              <td>{attributes.username}</td>
            </tr>
            <tr>
              <td><strong>Email</strong></td>
              <td>{attributes.email}</td>
            </tr>
            <tr>
              <td><strong>Carrier</strong></td>
              <td>{attributes.carrier_name}</td>
            </tr>
            <tr>
              <td><strong>User Type</strong></td>
              <td>{upperFirst(attributes.user_type)}</td>
            </tr>
            {this.carrierBrandRows}
          </tbody>
        </table>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const slice = state.users.show

  const configuration = state.login.session.configuration.users

  return {
    id: slice.id,
    attributes: slice.attributes,
    configuration
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  show: actions.show.main,
  reset: actions.show.reset
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CarrierUserShow))
